import { axiosInstance } from "@/config/axios";

export const customerEdit = async (uuid: string, note: string) => {
  const formData = new FormData();
  formData.append("note", note);
  return axiosInstance.post(`/contract/${uuid}/customer_edit`, formData);
};
